import { useSubheader } from "../../../../_metronic/layout";
import React from "react";
import {
  Form,
  Button,
  Col,
  Card,
} from "react-bootstrap";
import {Check2Circle} from "react-bootstrap-icons";
import {useHistory} from "react-router-dom";


export const SuccessfulVerification = () => {

  const history = useHistory();

  const suhbeader = useSubheader();

  suhbeader.setTitle("Receipt Verfication Successful");

  const handleVerifyAnother = () =>{

    history.push("/receipt-management");

  };


  return (
    <Card>
      <Card.Body>
        <Form>
          <Form.Row>
            <Col lg md={12} sm={12}>
              <Form.Label>
                <p style={{fontSize: "14px"}}>
                  <Check2Circle size={50} color="green" className="mr-5" />Receipt successfully verified and its status has been updated to <b>USED</b>. Please render service to customer.
                </p>
              </Form.Label>
            </Col>
          </Form.Row>
          <Button variant="primary" onClick={handleVerifyAnother}>Verify another receipt.</Button>
        </Form>
      </Card.Body>
    </Card>
  );
};
